import React, { useEffect, useState, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./CNCouncil.css";

/* Keep the data stable to avoid effect re-runs */
const PUBLIC = process.env.PUBLIC_URL || "";
const DEFAULT_PHOTO = `${PUBLIC}/defaultphoto/DefCNC3.png`;

const CITIES = [
    {
        name: "British Columbia Regional Council(BCRC)", lat: 53.7267, lng: -127.6476,
        logo: `${PUBLIC}/Cnclog/BritishColumbiaRC.png`,
        description: "<em>British Columbia is known for its natural beauty and Pacific coastline.</em>"
    },
    {
        name: "Central Alberta Council(CAC)", lat: 52.2681, lng: -113.8112,
        logo: `${PUBLIC}/Cnclog/CentralAlbertaRC.png`,
        description: "<em>Central Alberta city known for industry and scenic river valleys.</em>"
    },
    {
        name: "Central Manitoba Regional Council(CMRC)", lat: 49.8951, lng: -97.1384,
        logo: `${PUBLIC}/Cnclog/ManitobaRC.png`,
        description: "<em>Manitoba is a prairie province and home to Winnipeg, its capital.</em>"
    },
    {
        name: "Hamilton Ontario Triskelion Regional Council(HOTRC)", lat: 43.2557, lng: -79.8711,
        logo: `${PUBLIC}/Cnclog/HamiltonOntario.png`,
        description: ""
    },
    {
        name: "Lethbridge Triskelion Regional Council(LTRC)", lat: 49.6942, lng: -112.8328,
        logo: `${PUBLIC}/Cnclog/LethbridgeRC.png`,
        description: "<em>Southern Alberta city with strong agriculture and cultural roots.</em>"
    },
    {
        name: "Lloydminster AB/SK Regional Council(LASRC)", lat: 53.2780, lng: -110.0050,
        logo: `${PUBLIC}/Cnclog/LLoydMinsterRC.png`,
        description: "<em>Lloydminster is a unique city that straddles the border between Alberta and Saskatchewan.</em>"
    },
    {
        name: "London City Triskelion Regional Council(LCTRC)", lat: 42.9849, lng: -81.2453,
        logo: `${PUBLIC}/Cnclog/LondonCityRC.png`,
        description: "<em>London is a mid-sized city in southwestern Ontario, known for its education, health research, and vibrant Triskelion community.</em>"
    },
    {
        name: "Montreal Quebec Regional Council(MQRC)", lat: 45.51, lng: -73.56,
        logo: `${PUBLIC}/Cnclog/MontrealQuebecRC.png`,
        description: "<em>Montreal is the largest city in the province of Quebec.</em>"
    },
    {
        name: "Moose Jaw Triskelion Regional Council(MJTRC)", lat: 50.3934, lng: -105.5511,
        logo: `${PUBLIC}/Cnclog/MoosejawRC.png`,
        description: "<em>Moose Jaw is a city in southern Saskatchewan, known for its historic tunnels and cultural landmarks.</em>"
    },
   
    /*{
        name: "Medicine Hat Regional Council", lat: 50.0402, lng: -110.6766,
        logo: `${PUBLIC}/Cnclog/CNC2.png`,
        description: "<em>Southeast Alberta city, known for natural gas fields.</em>"
    },*/
    {
        name: "New Brunswick Regional Council(NBRC)", lat: 46.5653, lng: -66.4619,
        logo: `${PUBLIC}/Cnclog/NewBurnswickRC.png`,
        description: "<em>New Brunswick is one of Canada's Maritime provinces with a mix of forests and coastline.</em>"
    },
    {
        name: "Niagara Triskelion Regional Council(NTRC)", lat: 43.0896, lng: -79.0849,
        logo: `${PUBLIC}/Cnclog/NiagaraRC.png`,
        description: "<em>Niagara Falls is a city in Ontario known for the famous Niagara Falls waterfalls, a major tourist attraction and hydroelectric source.</em>"

    },
    {
        name: "Northern Alberta Council - Edmonton(NAC)", lat: 53.55, lng: -113.5,
        logo: `${PUBLIC}/Cnclog/EdmontonRC.png`,
        description: "<em>Edmonton is Alberta's capital, known for its massive river valley park system and cultural festivals.</em>"
    },
    {
        name: "North Peace Regional Council(NPRC)", lat: 64.2823, lng: -118.7947,
        logo: `${PUBLIC}/Cnclog/GrandePrairieRC.png`,
        description: "<em>Grande Prairie is a city in northwest Alberta.</em>"
    },
    {
        name: "Nova Scotia Regional Council(NSRC)", lat: 44.682, lng: -63.7443,
        logo: `${PUBLIC}/Cnclog/NovaScotiaRC.png`,
        description: "<em>Nova Scotia is known for its coastal beauty and maritime culture.</em>"
    },
    {
        name: "Prince Albert Regional Council(PARC)", lat: 53.2033,
        lng: -105.7531, logo: `${PUBLIC}/Cnclog/PrinceAlbertRC.png`,
        description: "<em>Prince Albert is the third-largest city in Saskatchewan and a gateway to the northern wilderness.</em>"
    },
    {
        name: "Prince Edward Island Triskelion Council(PEIRC)", lat: 46.5107, lng: -63.4168,
        logo: `${PUBLIC}/Cnclog/PrinceEdwardIslandRC.png`,
        description: "<em>The smallest province, known for red sand beaches and Anne of Green Gables.</em>"
    },
    {
        name: "Regina Saskatchewan Regional Council(RSRC)", lat: 50.4452, lng: -104.6189,
        logo: `${PUBLIC}/Cnclog/ReginaRC.png`,
        description: "<em>Capital of Saskatchewan and home to the RCMP Academy.</em>"
    },
    {
        name: "Southern Alberta Regional Council - Calgary(SARC)", lat: 51.05, lng: -114.07,
        logo: `${PUBLIC}/Cnclog/CalgaryRC.png`,
        description: "<em>Founded on November 15, 2004, with a residence of approximately ±160.</em>"
    },
    {
        name: "South Eastern Alberta Regional Council(SEARC)", lat: 50.0405, lng: -110.6765,
        logo: `${PUBLIC}/Cnclog/SouthEastAlbertaRC.png`,
        description: "<em>South East Alberta is known for its prairie landscapes, badlands, and sunny skies.</em>"
    },
    {
        name: "South East Manitoba Regional Council(SEMRC)", lat: 49.5258, lng: -96.6838,
        logo: `${PUBLIC}/Cnclog/SoutherEastRC.png`,
        description: "<em>Steinbach is the economic hub of Southeast Manitoba and one of the fastest growing cities in the province.</em>"
    },
    {
        name: "Saskatoon Triskelion Regional Council(STRC)", lat: 52.1332, lng: -106.67,
        logo: `${PUBLIC}/Cnclog/SaskatoonRC.png`,
        description: "<em>Largest city in Saskatchewan with vibrant culture and riverfront.</em>"
    },
    {
        name: "Tri-City Triskelion Regional Council(TCTRC)", lat: 49.2827, lng: -122.79,
        logo: `${PUBLIC}/Cnclog/TriCitiesRC.png`,
        description: "<em>The Tri-Cities include Coquitlam, Port Coquitlam, and Port Moody—three neighboring communities located east of Vancouver in British Columbia.</em>"
    },
    {
        name: "Triskelion National Capital Council - Ottawa(TNCC)", lat: 45.42, lng: -75.7,
        logo: `${PUBLIC}/Cnclog/OttawaGatineauRC.png`,
        description: "<em>Ottawa is the capital city of Canada.</em>"
    },
    {
        name: "Triskelion Ontario Regional Council(TORC)", lat: 43.6532, lng: -79.3832,
        logo: `${PUBLIC}/Cnclog/OntarioRC.png`,
        description: "<em>Ontario is Canada's most populous province and home to Toronto and Ottawa.</em>"
    },
    {
        name: "Vancouver Island Regional Council", lat: 49.6500, lng: -125.4500,
        logo: `${PUBLIC}/Cnclog/VancouverIslandRC.png`,
        description: "<em>Vancouver Island is known for its rugged Pacific coastline, lush forests, and vibrant island communities.</em>"
    },
    {
        name: "Windsor-Essex Regional Council",
        lat: 42.3149,
        lng: -83.0364,
        logo: `${PUBLIC}/Cnclog/WindsorEssexRC.png`,
        description: "<em>Windsor-Essex is known for its waterfront communities, rich automotive heritage, and Lake Erie shoreline.</em>"
    },
    {
        name: "Western Manitoba Regional Council(WMRC)", lat: 49.9, lng: -100.0,
        logo: `${PUBLIC}/Cnclog/WesternManitobaRC.png`,
        description: "<em>Western Manitoba includes communities such as Brandon and Virden, forming part of the agricultural and economic backbone of the province.</em>"
    },
];

/* ------------- CITY MODAL DETAILS ------------- */
const CITY_DETAILS =
{
    "British Columbia Regional Council": {
        logo: `${PUBLIC}/Cnclog/BritishColumbiaRC.png`,
        name: "British Columbia Regional Council",
        photo: `${PUBLIC}/CNCPhoto/BCRC.jpeg`,
        description: `
        The Triskelions’ Grand Fraternity and Sorority <strong>British Columbia Regional Council (BCRC)</strong> was formally established on July 12, 2001,
        in the Greater Vancouver Area by six immigrant Triskelion brothers from various Philippine chapters.
        As one of the earliest Tau Gamma Phi councils founded in Canada, BCRC grew from a small group into a strong and active membership.
        The council has since engaged in numerous civic and community initiatives—including bloodletting, food and clothing drives, volunteer work,
        and providing financial assistance to members and families. Today, BCRC stands as the only recognized council in British Columbia
        affiliated with the Canada National Council.<br/><br/>
        <strong>FB Page:</strong>

        <a href="https://www.facebook.com/share/1SRPWrS2sZ/" target="_blank">British Columbia Regional Council</a><br/>

        `
    },
    "Central Alberta Council": {
        logo: `${PUBLIC}/Cnclog/CentralAlbertaRC.png`,
        name: "Central Alberta Council",
        photo: `${PUBLIC}/CNCPhoto/CentralAlberta.jpeg`,
        description: `
        The <strong>Central Alberta Council</strong> traces its beginnings to the strong support and collaboration of the Southern Alberta Council in 2009.
        Through online connections, meetups, and shared initiatives, Triskelions in the region gradually formed a cohesive group.
        Continued engagement, gatherings, and commitment led to the establishment of the Interim Central Alberta Council (ICAC),
        whose founding members worked to build a structured and united organization. Recognition was later granted by the
        Canada National Council after the council demonstrated steady growth, teamwork, and adherence to the fraternity’s principles.<br/><br/>
        
        `
    },
    "Central Manitoba Regional Council": {
        logo: `${PUBLIC}/Cnclog/ManitobaRC.png`,
        name: "Manitoba Regional Council",
        photo: `${PUBLIC}/CNCPhoto/Manitoba.jpg`,
        description: `
        The <strong>Manitoba Regional Council</strong> grew as members gradually connected through workplace introductions, media announcements,
        and local meetups—strengthened further when Bro Edmund publicly acknowledged his fraternity ties, 
        leading to more Triskelions discovering one another. What began as small reunions eventually evolved into regular meetings, 
        celebrations, and community service initiatives. Today, the Manitoba Triskelions are a strong and diverse group of more than 80 members, 
        united in upholding the fraternity’s values and proudly representing Triskelions throughout the province.<br/><br/>
        
        `
    },
    "Hamilton Ontario Regional Triskelion Council": {
        logo: `${PUBLIC}/Cnclog/HamiltonOntario.png`,
        name: "Hamilton Ontario Regional Council",
        photo: `${PUBLIC}/CNCPhoto/HamiltionORC.jpeg`,
        description: `
        Founded on September 30, 2023, the Hamilton Ontario Triskelion Regional Council began with eight Triskelion brothers and one sister from various
        Philippine chapters who shared a common purpose rooted in faith, family, work, service, and fraternity. United by these values and guided by Triskelion
        principles, the council formally organized to strengthen fellowship and build a community anchored in free will, unity, and brotherhood.<br/><br/>
        
        `
    },
  
    "Lethbridge Triskelion Regional Council": {
        logo: `${PUBLIC}/Cnclog/LethbridgeRC.png`,
        name: "Lethbridge Triskelion Regional Council",
        photo: `${PUBLIC}/CNCPhoto/LTRC.jpeg`,
        description: `
        The <strong>Lethbridge Triskelion Regional Council</strong> was established on July 15, 2024,
        with the vision of uniting Triskelions in Lethbridge and ensuring that brothers and sisters in the area have a strong support system.
        Through the dedication of Sis Mica Encarnacion, Brother Chucky Encarnacion, and Brother Gerry Saguin in coordination with the Southern Alberta Council,
        LTRC successfully received recognition from CNC. SOAL played a significant role in this achievement, with Brother Marty, former chairman of SOAL,
        and Brother Ferdz providing unwavering support and guidance throughout the establishment process.<br/><br/>
        
        `
    },
    "Lloydminster AB/SK Regional Council": {
        logo: `${PUBLIC}/Cnclog/LLoydMinsterRC.png`,
        name: "Lloydminster Regional Council",
        photo: `${PUBLIC}/CNCPhoto/LlyodMinsterRC.jpeg`,
        description: `
        The <strong>Lloydminster Regional Council</strong> was founded by seven Triskelion brothers and sisters from various Philippine chapters who were united
        by their dedication to the principles of kapatiran. Their strong commitment to unity and collaboration laid the foundation for the council, 
        which was officially recognized by the CNC on March 19, 2017. Since then, the council has continued to grow and develop meaningful community ties 
        while upholding the core values of the Triskelion brotherhood and sisterhood.<br/><br/>
        
        `
    },
    "London City Triskelion Regional Council": {
        logo: `${PUBLIC}/Cnclog/LondonCityRC.png`,
        name: "London City Triskelion Regional Council",
        photo: `${PUBLIC}/CNCPhoto/LondonCityRC.jpeg`,
        description: `
        The <strong>London City Triskelion Regional Council</strong> was established on September 24, 2023, when Triskelions in London,
        Ontario gathered for the first general assembly. This founding moment laid the groundwork for a council built on resilience, free will, and
        the enduring principles of the fraternity. Guided by the “3 Dynamic Forces”—Fortitude, Free Will, and Brotherhood—the council continues to uphold unity,
        loyalty, and service while inspiring future members to lead with strength and purpose.<br/><br/>
        
        `
    },
    "Montreal Quebec Regional Council": {
        logo: `${PUBLIC}/Cnclog/MontrealQuebecRC.png`,
        name: "Montreal Quebec Regional Council",
        photo: `${PUBLIC}/CNCPhoto/MontrealQ.jpg`,
        description: `
        The <strong>Montreal Quebec Regional Council</strong> was organized by Triskelions residing across the Montreal area and nearby Quebec communities.
        Built through the efforts of early members from various Philippine chapters, the group formed a strong foundation rooted in unity and communication.
        Through consistent gatherings and strengthened relationships, they officially established the Montreal Quebec Regional Council on October 4, 2008. Today,
        the MQRC serves as the home for Triskelions throughout Quebec, fostering brotherhood and active community involvement.<br/><br/>
        
        `
    },
    "Moose Jaw Regional Triskelion Council": {
        logo: `${PUBLIC}/Cnclog/MoosejawRC.png`,
        name: "Moose Jaw Regional Council",
        photo: `${PUBLIC}/CNCPhoto/MooseJawRC.jpeg`,
        description: `
        Founded on May 15, 2017 under the recognition of the Canada National Council, the Moose <strong>Jaw Triskelion Regional Council</strong>
        was formed by Triskelions from diverse Philippine chapters who found new opportunities and community in Saskatchewan.
        Guided by loyalty, unity, and unwavering dedication, the council steadily grew with support from members across nearby towns and cities.
        Today, the Moose Jaw council continues to thrive as a source of strength, brotherhood, and hope for Triskelions in the region.<br/><br/>
        
        `
    },
    "New Brunswick Regional Council": {
        logo: `${PUBLIC}/Cnclog/NewBurnswickRC.png`,
        name: "New Brunswick Regional Council",
        photo: `${PUBLIC}/CNCPhoto/NewBrunswick.jpg`,
        description: `
        Triskelions first arrived in <strong>New Brunswick</strong> in 2008–2009, but formal council development began years later through connections with the
        Nova Scotia Regional Council (NSRC). Between 2013 and 2018, more Triskelions settled in NB and became registered members under NSRC.
        The idea of establishing a New Brunswick Regional Council (NBRC) emerged during fraternity anniversary celebrations and was revisited in 2020.
        With renewed support from Triskelions in NB and NSRC leadership, the council finally progressed toward formation,
        marking a significant milestone for the Triskelion community across the province.<br/><br/>
        
        `
    },
    "Niagara Triskelion Regional Council": {
        logo: `${PUBLIC}/Cnclog/NiagaraRC.png`,
        name: "Niagara Triskelion Regional Council",
        photo: `${PUBLIC}/CNCPhoto/Niagara1P.jpg`,
        description: `
        The <strong>Niagara Triskelion Regional Council</strong> traces its birth to July 17, 2022, when three Triskelions gathered in Niagara-on-the-Lake
        and envisioned establishing a welcoming council for fellow members in the region. Guided by the Tenets and Code of Conduct, they embraced the mission
        of supporting Triskelions relocating to Niagara. The council’s logo symbolizes the 12 municipalities, 5 cities, 5 towns, and 2 townships of the region.
        NTARC remains committed to camaraderie, leadership, service, and community responsibility throughout the Niagara area.<br/><br/>

         <strong>Webpage:</strong> 
         <a href="https://niagaratriskelion.com/" target="_blank">https://niagaratriskelion.com</a><br/>

         <strong>Email:</strong> 
         <a href="mailto:hello@niagaratriskelion.com">hello@niagaratriskelion.com</a>
         
         `
    },
    "Northern Alberta Council - Edmonton": {
        logo: `${PUBLIC}/Cnclog/EdmontonRC.png`,
        name: "Northern Alberta Council - Edmonton",
        photo: `${PUBLIC}/CNCPhoto/Edmonton.jpg`,
        description: `
        The <strong>Northern Alberta Council</strong> began through efforts in 2007 to locate Triskelions living in Edmonton.
        Early members connected through referrals and online platforms, slowly forming the first core group.
        This pioneering batch held the first General Assembly on October 4, 2008, marking the beginning of formal council development.
        As membership expanded, more Triskelions were verified and recognized, leading to the first election of officers for the 2008–2009 term.
        On May 6, 2009, the council was officially incorporated and later received recognition from the Canada National Council.
        oday, Northern Alberta continues to grow and uphold the fraternity’s mission of service and unity.<br/><br/>
        
        `
    },
    "North Peace Regional Council": {
        logo: `${PUBLIC}/Cnclog/GrandePrairieRC.png`,
        name: "Grande Prairie Regional Council",
        photo: `${PUBLIC}/CNCPhoto/GrandPrairieRC.jpeg`,
        description: `
        Established on October 7, 2018, the <strong>North Peace Regional Council (formerly Grande Prairie Regional Council)</strong> was formed
        by Triskelions residing in Northwestern Alberta. As membership expanded throughout Peace River Country, the council voted in 2024
        to adopt the name North Peace Regional Council to reflect its growing regional coverage, including Fort St. John, Dawson Creek,
        Tumbler Ridge, and other surrounding communities. Despite long travel distances, members consistently gather for activities, outreach programs,
        and community service, proving that unity transcends geographical challenges.<br/><br/>
        
        `
    },
    "Nova Scotia Regional Council": {
        logo: `${PUBLIC}/Cnclog/NovaScotiaRC.png`,
        name: "Nova Scotia Regional Council",
        photo: `${PUBLIC}/CNCPhoto/NocaScotiaRC.jpeg`,
        description: `
        Founded on March 17, 2014, the <strong>Nova Scotia Regional Council</strong> upholds the enduring spirit of Triskelionism across the Maritime provinces.
        Beginning with Bro. Jude Oraa connecting with fellow Triskelions in Halifax, the group eventually formed a committed council guided
        by the principle of supporting one another. As the first council established in Nova Scotia, its founding members initiated community
        activities and outreach programs, demonstrating that even in a smaller province, the spirit of brotherhood, service,
        and positive impact can thrive.<br/><br/>
        
        `
    },
    "Prince Albert Regional Council": {
        logo: `${PUBLIC}/Cnclog/PrinceAlbertRC.png`,
        name: "Prince Albert Regional Council",
        photo: `${PUBLIC}/CNCPhoto/PrinceAlbertRC.jpeg`,
        description: `
        Founded on March 25, 2018, the <strong>Prince Albert Regional Council</strong> began with ten pioneering members committed to community service and Triskelion brotherhood.
        The council has since supported various initiatives, including feeding programs in Las Piñas, Philippines, local blood donation drives,
        clothing donations, and outreach activities for elders during special occasions. PARC continues to strengthen unity and service within
        the Prince Albert community.<br/><br/>
        
        `
    },
    "Prince Edward Island Triskelion Regional Council": {
        logo: `${PUBLIC}/Cnclog/PrinceEdwardIslandRC.png`,
        name: "Prince Edward Island Triskelion Regional Council",
        photo: `${PUBLIC}/CNCPhoto/PrinceEdwardIRC.jpeg`,
        description: `
        The <strong>Prince Edward Island Triskelion Regional Council (PEITRC)</strong> was officially founded and recognized by the Canada National Council on August 26, 2022.
        The council began when Triskelion brothers in Cavendish, PEI connected and formed a unified group anchored on the fraternity’s principles.
        With early support from members of New Brunswick and other regions, PEITRC strengthened its foundation and established its presence in the province.
        Today, the council continues to uphold Triskelion values through fellowship, unity, and community involvement.<br/><br/>
        
        `
    },
    "Regina Saskatchewan Regional Council": {
        logo: `${PUBLIC}/Cnclog/ReginaRC.png`,
        name: "Regina Saskatchewan Regional Council",
        photo: `${PUBLIC}/CNCPhoto/ReginaSaskatchwan.jpg`,
        description: `
        The <strong>Regina Saskatchewan Regional Council</strong> was founded on September 17, 2013, by Triskelions who sought
        to embrace the Tenets and Codes of Conduct within the growing Filipino community in Regina and nearby areas.
        Initially known as the Southern Saskatchewan Regional Council, it was later renamed Regina Saskatchewan Regional Council
        after receiving recognition from the Canada National Council. Its founding members worked to unify Triskelions across the region and
        establish a meaningful presence rooted in fellowship and service.<br/><br/>
        
        `
    },
    "Southern Alberta Regional Council - Calgary": {
        logo: `${PUBLIC}/Cnclog/CalgaryRC.png`,
        name: "Southern Alberta Regional Council - Calgary",
        photo: `${PUBLIC}/CNCPhoto/SouthernAlberta.jpg`,
        description: `
        On November 15, 2004, the  <strong>Southern Alberta Regional Council</strong> was officially founded in Calgary, marking the formal establishment of Tau Gamma Phi in the
        region. As more brothers and sisters arrived in the city and reconnected with the fraternity, the council steadily grew into a strong and active community. This progress led to its first anniversary celebration on October 4, 2007, symbolizing the council’s continued expansion and deepening sense of unity. Today, the Southern Alberta Triskelions remain guided by the same spirit of brotherhood, service, and solidarity that shaped their early years.
        
        `
    },
    "South Eastern Alberta Regional Council": {
        logo: `${PUBLIC}/Cnclog/SouthEastAlbertaRC.png`,
        name: "South Eastern Alberta Regional Council",
        photo: `${PUBLIC}/CNCPhoto/SouthEastAlbertaRC.jpeg`,
        description: `
       
        `
    },
    "South East Manitoba Regional Council": {
        logo: `${PUBLIC}/Cnclog/SoutherEastRC.png`,
        name: "Southeast Manitoba Regional Council",
        photo: `${PUBLIC}/CNCPhoto/SEManitobaRC.jpeg`,
        description: `
        The <strong>South East Manitoba Regional Council</strong>  was established on January 16, 2021, during the pandemic era.
        Formed by eight bona fide brothers and one sister from diverse Philippine chapters, the council received sponsorship from the
        Central Manitoba Regional Council before gaining CNC recognition. Today, SEMRC continues to uphold Triskelion values while serving communities
        across Southeast Manitoba.
        
        `
    },
    "Saskatoon Regional Council": {
        logo: `${PUBLIC}/Cnclog/SaskatoonRC.png`,
        name: "Saskatoon Regional Council",
        photo: `${PUBLIC}/CNCPhoto/SaskatoonRC.jpeg`,
        description: ""
    },
    "Tri-City Triskelion Regional Council": {
        logo: `${PUBLIC}/Cnclog/TriCitiesRC.png`,
        name: "Tri-City Triskelion Regional Council",
        photo: `${PUBLIC}/CNCPhoto/Tri-city.jpg`,
        description: `
        <strong>Tri-City Triskelion Regional Council</strong> traces its beginnings to 2018, when Triskelion brothers in Waterloo Region initiated meetups across Kitchener,
        Waterloo, and Guelph. Despite distance challenges, the group grew steadily, especially during the pandemic. Motivated by unity and mutual support,
        the members officially formed Tri-City Triskelions on September 11, 2021, followed by CNC recognition on September 11, 2022.
        The council remains active in community service, including clean-up drives, blood donation initiatives, and food bank outreach.<br/><br/>
        
        `
    },
    "Triskelion National Capital Council - Ottawa": {
        logo: `${PUBLIC}/Cnclog/OttawaGatineauRC.png`,
        name: "Triskelion National Capital Council - Ottawa",
        photo: `${PUBLIC}/CNCPhoto/OttawaTNCC.jpeg`,
        description: `
        The <strong>Triskelion National Capital Counci</strong>l traces its beginnings to a Facebook group chat created in July 2018,
        which led to the first official meetup at Billings Bridge Mall in Ottawa. The initiative quickly united brothers and sisters
        living in the National Capital Region. By August 2018, seven founding members formed TNCC, and the group soon received sponsorship support
        from Toronto and Montreal councils. TNCC achieved official CNC recognition following its Golden Anniversary gathering on October 6, 2018.
        Today, TNCC continues to serve the community with strong leadership and active brotherhood and sisterhood.<br/><br/>
        
        `
    },
    "Triskelion Ontario Regional Council": {
        logo: `${PUBLIC}/Cnclog/OntarioRC.png`,
        name: "Ontario Regional Council",
        photo: `${PUBLIC}/CNCPhoto/OntarioRC.jpeg`,
        description: `
         The <strong>Triskelion Ontario Regional Council</strong> – GTA originated from early gatherings that began in 2002,
         formed by Brods and Sis who prioritized building a strong and unified council rather than identifying a specific founding
         date or claiming credit as founders.Their focus was on establishing principles, structure, and a cohesive identity
         that would guide the council into the future. The council’s formation centered on creating meaningful activities and initiatives
         that would bring together all Triskelions in Ontario and strengthen their sense of family and unity.<br/><br/>
        
         `
    },
    "Vancouver Island Regional Council": {
        logo: `${PUBLIC}/Cnclog/VancouverIslandRC.png`,
        name: "Vancouver Island Regional Council",
        photo: `${PUBLIC}/CNCPhoto/VancouverIslandRC.jpeg`,
        description: `
        `
    },

    "Windsor-Essex Regional Council": {
        logo: `${PUBLIC}/Cnclog/WindsorEssexRC.png`,
        name: "Windsor-Essex Regional Council",
        photo: `${PUBLIC}/CNCPhoto/WindsorEssexRC.jpeg`,
        description: `
        `
    },
    "Western Manitoba Regional Council": {
        logo: `${PUBLIC}/Cnclog/WesternManitobaRC.png`,
        name: "Western Manitoba Regional Council",
        photo: `${PUBLIC}/CNCPhoto/WestManitobaRC.jpeg`,
        description: `
        The  <strong>Western Manitoba Regional Council</strong> was founded by seven dedicated Triskelion brothers who shared a commitment to fraternity brotherhood and values.
        Their coordinated efforts, inspired by Triskelions across Canada and the Philippines, established a strong foundation for the group.
        Their unity and dedication led to official recognition by the Canada National Council on November 11, 2013,
        marking a milestone in strengthening camaraderie within the region.<br/><br/>
        
        `
    },

};

const CITY_DETAIL_KEYS = Object.keys(CITY_DETAILS);
const getCityDetails = (cityName) => {
    if (!cityName) return null;
    const direct = CITY_DETAILS[cityName];
    if (direct) return direct;
    const withoutAbbreviation = cityName.replace(/\s*\([^)]*\)\s*$/, "").trim();
    if (CITY_DETAILS[withoutAbbreviation]) return CITY_DETAILS[withoutAbbreviation];
    const cityIndex = CITIES.findIndex((city) => city.name === cityName);
    return cityIndex >= 0 ? CITY_DETAILS[CITY_DETAIL_KEYS[cityIndex]] || null : null;
};

/* ================ MAIN COMPONENT ================== */
export default function CNCouncil() {
    const isClient = typeof window !== "undefined";
    const [isMobile, setIsMobile] = useState(() => (isClient ? window.innerWidth <= 768 : false));
    const [currentIndex, setCurrentIndex] = useState(0);
    const [hoveredCity, setHoveredCity] = useState(null);
    const [modalCity, setModalCity] = useState(null);
    const [fullPhoto, setFullPhoto] = useState(null);  

    const mapRef = useRef(null);
    const mapInstanceRef = useRef(null);
    const markerRefs = useRef([]);
    const mobileTouchStartX = useRef(null);
    const [selectedMobileLogo, setSelectedMobileLogo] = useState(null);

    const containerStyle = {
        "--cnc-bg": `url("${PUBLIC}/larawan/TGPLogoCNCD.png")`,
        "--cnc-mobile-bg": `url("${PUBLIC}/larawan/TGPLogoCNCM.png")`,
    };

    const cityNames = CITIES.map(c => c.name);
    const modalDetails = getCityDetails(modalCity);
    const modalCityData = CITIES.find((city) => city.name === modalCity);

    const getCurrentCityIndex = () =>
        cityNames.indexOf(modalCity);

    const goPrevCity = () => {
        const idx = getCurrentCityIndex();
        setModalCity(cityNames[(idx - 1 + cityNames.length) % cityNames.length]);
    };

    const goNextCity = () => {
        const idx = getCurrentCityIndex();
        setModalCity(cityNames[(idx + 1) % cityNames.length]);
    };



    /* ===== Fade on scroll ===== */
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                entry.target.classList.toggle("animate", entry.isIntersecting);
            });
        });

        const els = document.querySelectorAll(".animated-line");
        els.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    /* ===== Resize listener ===== */
    useEffect(() => {
        if (!isClient) return;
        const onResize = () => setIsMobile(window.innerWidth <= 768);

        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, [isClient]);

    /* ===== Initialize/destroy map ===== */
    useEffect(() => {
        if (isMobile) {
            if (mapInstanceRef.current) {
                mapInstanceRef.current.remove();
                mapInstanceRef.current = null;
            }
            if (mapRef.current) {
                mapRef.current.innerHTML = "";
                mapRef.current.removeAttribute("data-leaflet-id");
            }
            return;
        }

        if (!mapRef.current || mapInstanceRef.current) return;

        const map = L.map(mapRef.current, {
            center: [56.1304, -106.3468],
            zoom: 4,
            dragging: true,
            zoomControl: true,
            scrollWheelZoom: false,
            attributionControl: false,
        });

        mapInstanceRef.current = map;

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(map);

        markerRefs.current = CITIES.map((city) => {
            const icon = L.icon({
                iconUrl: city.logo,
                iconSize: [40, 40],
                iconAnchor: [20, 40],
                popupAnchor: [0, -40],
                className: "custom-logo-marker",
            });

            const marker = L.marker([city.lat, city.lng], { icon }).addTo(map);

            /* ---------- Popup with SEE MORE button ---------- */
            marker.bindPopup(
                            `
            <div class="popup-content">
                <strong>${city.name}</strong><br/>
                <img src="${city.logo}" alt="Logo" width="50"/><br/>
                <div class="popup-desc">${city.description}</div>
                <button class="popup-see-more" data-city="${city.name}">
                    See More
                </button>
            </div>
            `
            );

            /* ---------- Attach click event after popup opens ---------- */
            marker.on("popupopen", () => {
                const selector = `.popup-see-more[data-city="${city.name}"]`;
                const btn = document.querySelector(selector);

                if (!btn) return;

                const handleClick = () => setModalCity(city.name);

                btn.addEventListener("click", handleClick);

                // Remove listener when popup closes to prevent duplicates
                marker.once("popupclose", () => {
                    btn.removeEventListener("click", handleClick);
                });
            });


            return marker;
        });

        setTimeout(() => map.invalidateSize(), 100);

        return () => {
            mapInstanceRef.current?.remove();
            mapInstanceRef.current = null;
        };
    }, [isMobile]);

    /* ===== Hover effect for markers ===== */
    useEffect(() => {
        if (!mapInstanceRef.current) return;

        markerRefs.current.forEach((marker, idx) => {
            const size = hoveredCity === idx ? [70, 70] : [40, 40];
            marker.setIcon(
                L.icon({
                    iconUrl: CITIES[idx].logo,
                    iconSize: size,
                    iconAnchor: [20, 40],
                    popupAnchor: [0, -40]
                })
            );
        });
    }, [hoveredCity]);

    const handlePrev = () =>
        setCurrentIndex((i) => (i - 1 + CITIES.length) % CITIES.length);

    const handleNext = () =>
        setCurrentIndex((i) => (i + 1) % CITIES.length);

    const handleMobileTouchStart = (event) => {
        mobileTouchStartX.current = event.touches[0]?.clientX ?? null;
    };

    const handleMobileTouchEnd = (event) => {
        if (mobileTouchStartX.current === null) return;

        const endX = event.changedTouches[0]?.clientX ?? mobileTouchStartX.current;
        const deltaX = endX - mobileTouchStartX.current;
        mobileTouchStartX.current = null;

        if (Math.abs(deltaX) < 45) return;
        if (deltaX > 0) {
            handlePrev();
        } else {
            handleNext();
        }
    };

    const handleLogoClick = (index) => {
        const marker = markerRefs.current[index];

        if (marker && mapInstanceRef.current) {
            // Scroll to the map
            const mapElement = document.getElementById("map");
            if (mapElement) {
                mapElement.scrollIntoView({ behavior: "smooth", block: "center" });
            }

            // Wait for scroll animation
            setTimeout(() => {
                mapInstanceRef.current.setView(marker.getLatLng(), 7);
                marker.openPopup();
            }, 600);
        }
    };

    const mobilePrevIndex = (currentIndex - 1 + CITIES.length) % CITIES.length;
    const mobileNextIndex = (currentIndex + 1) % CITIES.length;



    return (
        <section id="cncouncils" className="cncouncil-container" style={containerStyle}>
            <h2 className="cnc-title">
                Connecting Triskelions across the provinces to uphold the legacy of the fraternity.
            </h2>

            <div className="cnc-logo-stage" aria-label="Canada National Council logo">
                <span className="cnc-logo-orbit" aria-hidden="true" />
                <img src={`${PUBLIC}/logos/CNC3.png`} alt="CNC Logo" className="cnc-logo" />
            </div>

            {/* ---------------- MOBILE VIEW ---------------- */}
            {isMobile ? (
                <div className="mobile-view">
                    <div className="mobile-flipster-stage" aria-label="Regional council carousel">
                        <button className="mobile-flipster-arrow left" onClick={handlePrev} aria-label="Previous council">
                            <span aria-hidden="true">&#10094;</span>
                        </button>

                        <div
                            className="mobile-flipster-deck"
                            onTouchStart={handleMobileTouchStart}
                            onTouchEnd={handleMobileTouchEnd}
                        >
                            <img
                                src={CITIES[mobilePrevIndex].logo}
                                alt=""
                                className="mobile-flipster-card side prev"
                                aria-hidden="true"
                                onClick={handlePrev}
                            />
                            <img
                                src={CITIES[currentIndex].logo}
                                alt={CITIES[currentIndex].name}
                                className="mobile-flipster-card active"
                            />
                            <img
                                src={CITIES[mobileNextIndex].logo}
                                alt=""
                                className="mobile-flipster-card side next"
                                aria-hidden="true"
                                onClick={handleNext}
                            />
                        </div>

                        <button className="mobile-flipster-arrow right" onClick={handleNext} aria-label="Next council">
                            <span aria-hidden="true">&#10095;</span>
                        </button>
                    </div>

                    <div className="mobile-logo-wrapper">
                        <button className="nav-arrow left" onClick={handlePrev}>❮</button>
                        <img
                            src={CITIES[currentIndex].logo}
                            alt={CITIES[currentIndex].name}
                            className="mobile-logo"
                        />
                        <button className="nav-arrow right" onClick={handleNext}>❯</button>

                    </div>

                    <h3>{CITIES[currentIndex].name}</h3>
                    <p dangerouslySetInnerHTML={{ __html: CITIES[currentIndex].description }} />

                    {/* SEE MORE button for mobile */}
                    <button
                        className="see-more-btn-mobile"
                        onClick={() => setModalCity(CITIES[currentIndex].name)}
                    >
                        See More
                    </button>
                </div>
            ) : (
                <div id="map" ref={mapRef} className="map-view" />
            )}

            {/* ---------------- DESKTOP LOGO GRID (NO MODAL) ---------------- */}
            <div className="logo-grid">
                {CITIES.map((city, index) => (
                    <div
                        key={city.name}
                        className="grid-logo"

                        /* DESKTOP: hover highlight only */
                        onMouseEnter={() => !isMobile && setHoveredCity(index)}
                        onMouseLeave={() => !isMobile && setHoveredCity(null)}

                        /* DESKTOP click → center map / MOBILE click → show tooltip */
                        onClick={() => {
                            if (isMobile) {
                                setSelectedMobileLogo(index);
                            } else {
                                handleLogoClick(index);
                            }
                        }}

                        /* DESKTOP tooltip restored */
                        title={!isMobile ? city.name : ""}
                    >
                        <img src={city.logo} alt={city.name} />

                        {/* MOBILE floating tooltip */}
                        {isMobile && selectedMobileLogo === index && (
                            <div className="mobile-logo-tooltip">{city.name}</div>
                        )}
                    </div>
                ))}
            </div>


            {/* ---------------- INTRO TEXT ---------------- */}
            <div className="cncouncil-intro">
                <div className="animated-line delay-1">
                    <h2>CANADA NATIONAL COUNCIL, INC.</h2>
                    The <strong>Tau Gamma Phi and Tau Gamma Sigma Grand Fraternity and Sorority – Canada National Council, Inc.
                    (CNC)</strong> is the official national governing body of Tau Gamma Phi and Tau Gamma Sigma in Canada.
                </div>
                <p className="animated-line delay-2">
                    The foundation of the Canada National Council began during the <strong>First International Summit in January 2008 in California,</strong> where
                    Canada was represented by <strong>Brod. Alan Cruz.</strong> This initiative led to the formal establishment of the CNC on <strong>September 19, 2009,</strong> through
                    the unified efforts of councils from Winnipeg, Vancouver, Toronto, and Calgary.
                </p>
                <p className="animated-line delay-3">
                    Today, the <strong>CNC</strong> represents over 1,000 members across 24 established regional councils nationwide,
                    with continued expansion anticipated as the organization grows and new councils are formed. Operating as a non-profit organization,
                    it provides national leadership, governance, and coordination while safeguarding the unity, standards,
                    and long-term continuity of the fraternity and sorority throughout Canada.
                </p>
                <p className="animated-line delay-4">
                    The <strong>Canada National Council</strong> serves as the central body that connects regional councils, ensures organizational stability,
                    and upholds the values and legacy of Tau Gamma Phi and Tau Gamma Sigma across the country.
                </p>
                <div className="animated-line delay-5">
                    <h3>Premiers of the Canada National Council</h3>

                    <div className="premiers-grid">
                        <span>Brod. Alan Cruz (2009)</span>
                        <span>Brod. Oscar De Paula (2010–2012)</span>

                        <span>Brod. Donnie Arteta (2013)</span>
                        <span>Brod. Lito Velasco (2014)</span>

                        <span>Brod. Norman Dallo (2015)</span>
                        <span>Brod. Cesar Fabian (2016)</span>

                        <span>Brod. Marloun Manuel (2017–2018)</span>
                        <span>Brod. Martin Sia (Jan–Oct 2019)</span>

                        <span>Brod. Kirby Sisson (Nov–Dec 2019)</span>
                        <span>Sis. Victoria de Lara (2020–2021)</span>

                        <span>Brod. Toffey Perlas (2022–2023)</span>
                        <span>Brod. Ramil Abad (2024)</span>

                        <span>Sis. Victoria de Lara (2025)</span>
                        <span>Brod. Reynaldo Arcenas Jr. (2026)</span>
                    </div>
                </div>

            </div>

            {/* ---------------- MODAL ---------------- */}
            {modalCity && (
                <div className="modal-overlay" onClick={() => setModalCity(null)}>
                    <div className="modal-box" onClick={(e) => e.stopPropagation()}>

                        {/* CLOSE */}
                        <button className="modal-close" onClick={() => setModalCity(null)}>
                            ✖
                        </button>

                        {/* PREV / NEXT NAV */}
                        <div className="logo-nav-wrapper">
                            <button className="nav-arrow" onClick={goPrevCity}>
                                ❮
                            </button>

                            <div className="logo-circle">
                                <img src={modalDetails?.logo || modalCityData?.logo || `${PUBLIC}/Cnclog/CNC2.png`} alt="Logo" />
                            </div>

                            <button className="nav-arrow" onClick={goNextCity}>
                                ❯
                            </button>
                        </div>


                        {modalDetails ? (
                            <>
                                <h2 className="modal-title">
                                    {modalDetails.name}
                                </h2>

                                <img
                                    src={modalDetails.photo || DEFAULT_PHOTO}
                                    className="modal-photo"
                                    alt="Council"
                                    onClick={() =>
                                        setFullPhoto(
                                            modalDetails.photo || DEFAULT_PHOTO
                                        )
                                    }
                                />

                                <div
                                    className="modal-description"
                                    dangerouslySetInnerHTML={{
                                        __html: modalDetails.description
                                    }}
                                />
                            </>
                        ) : (
                            <>
                                <h2 className="modal-title">{modalCity}</h2>
                                <p className="modal-description">
                                    More information is coming soon…
                                </p>
                            </>
                        )}
                    </div>
                </div>
            )}


            {/* ------------ FULLSCREEN PHOTO VIEWER ------------- */}
            {fullPhoto && (
                <div className="photo-viewer-overlay" onClick={() => setFullPhoto(null)}>
                    <div
                        className="photo-viewer-box"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className="photo-viewer-close" onClick={() => setFullPhoto(null)}>
                            ✖
                        </button>

                        <img src={fullPhoto} alt="Full View" className="photo-viewer-img" />
                    </div>
                </div>
            )}
  
        </section>
    );
}

